module.exports = __webpack_public_path__ + "static/media/event-created.ecf704bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/event-created.svg
// module id = 1227
// module chunks = 0